export const environment = {
  production: true,
  domain: 'https://fresh-tap.web.app',
  firebase: {
    projectId: 'fresh-tap',
    appId: '1:52253841599:web:457909ad6513e0531b4e0a',
    storageBucket: 'fresh-tap.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyD8u8_tYdaqU6XUzjxjmNgpWchVdoQz9aU',
    authDomain: 'fresh-tap.firebaseapp.com',
    messagingSenderId: '52253841599',
    measurementId: 'G-VYFSJ86CLN',
  },
};
